import React from 'react';

export interface PortraitMediaFrameProps {
  children: React.ReactNode;
  /** Optional poster / thumbnail shown behind media */
  poster?: string;
  /** Max width in px — height follows 9:16 */
  size?: number;
  className?: string;
}

/** 9:16 frame for vertical (mobile) video previews */
const PortraitMediaFrame: React.FC<PortraitMediaFrameProps> = ({
  children,
  poster,
  size = 220,
  className = '',
}) => (
  <div
    className={`portrait-media-frame mx-auto ${className}`.trim()}
    style={{
      width: size,
      maxWidth: '100%',
      aspectRatio: '9 / 16',
      borderRadius: 14,
      overflow: 'hidden',
      background: poster
        ? `#111 url("${poster}") center / cover no-repeat`
        : 'linear-gradient(160deg, #1e293b 0%, #0f172a 55%, #020617 100%)',
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.18), inset 0 0 0 1px rgba(255, 255, 255, 0.06)',
      position: 'relative',
    }}
  >
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: poster ? 'rgba(0,0,0,0.25)' : undefined,
      }}
    >
      {children}
    </div>
  </div>
);

export default PortraitMediaFrame;
